<template>
    <div id="not-found">
        <div class="error-message">
            <p>404 Страница не найдена</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "404"
    }
</script>